/* Lumix Schnellbestellung (assets/lx-schnellbestellung.js) - Aufbau und Gestaltung in sections/lx-schnellbestellung.liquid.
   15.10.2026: D-Dome/S-Dome robust erkannt (auch bei getrenntem Bindestrich aus dem PDF), Mehrpreis von Enerack wird angezeigt. */
(function () {
  var root = document.getElementById('lxqo');
  if (!root) return;
  var SHOP_MAIL = root.getAttribute('data-mail') || '';
  var CUR = root.getAttribute('data-cur') || 'EUR';
  var $ = function (s) { return root.querySelector(s); };
  var fmt = function (c) { return (c / 100).toLocaleString('de-AT', { style: 'currency', currency: CUR }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var norm = function (s) { return String(s == null ? '' : s).trim().toUpperCase().replace(/^K2[-\s]?/, '').replace(/\s+/g, ''); };

  /* ---------- 1. Shop-Daten laden (live, Montagesysteme + Unterkonstruktion-Sets) ---------- */
  var IDX = {}, PRODUCTS = [], SETS = [], loaded = null;
  function addKey(k, entry) { k = norm(k); if (!k || k.length < 3) return; if (!IDX[k]) IDX[k] = entry; var z = k.replace(/^0+/, ''); if (z && z !== k && !IDX[z]) IDX[z] = entry; }
  function ingest(p, isSet) {
    PRODUCTS.push(p);
    if (isSet) SETS.push(p);
    var v0 = p.vs && p.vs[0];
    (p.n || []).forEach(function (n) { if (n) addKey(n, { p: p, v: v0, alt: null }); });
    (p.vs || []).forEach(function (v) { if (v.s) addKey(v.s, { p: p, v: v, alt: null }); if (v.b) addKey(v.b, { p: p, v: v, alt: null }); });
    (p.a || []).forEach(function (n) { if (n) addKey(n, { p: p, v: v0, alt: n }); });
  }
  function loadColl(handle, isSet) {
    var get = function (pg) { return fetch('/collections/' + handle + '?view=lxqo&page=' + pg, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); }); };
    return get(1).then(function (d) {
      d.p.forEach(function (p) { ingest(p, isSet); });
      var jobs = [];
      for (var i = 2; i <= d.pages; i++) jobs.push(get(i));
      return Promise.all(jobs).then(function (all) { all.forEach(function (x) { x.p.forEach(function (p) { ingest(p, isSet); }); }); });
    });
  }
  function ensureData() {
    if (!loaded) loaded = Promise.all([loadColl('montagesysteme', false), loadColl('unterkonstruktion-sets', true)]);
    return loaded;
  }

  /* ---------- 2. Dateien lesen ---------- */
  function loadScript(src) { return new Promise(function (ok, no) { var s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = no; document.head.appendChild(s); }); }
  function libXlsx() { return window.XLSX ? Promise.resolve() : loadScript('https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js'); }
  function libPdf() {
    if (window.pdfjsLib) return Promise.resolve();
    return loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js').then(function () {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
    });
  }
  function readBuf(file) { return new Promise(function (ok, no) { var r = new FileReader(); r.onload = function () { ok(r.result); }; r.onerror = no; r.readAsArrayBuffer(file); }); }

  function linesFromSheetRows(rows) {
    var H = -1, cNum = -1, cQty = -1, cName = -1;
    for (var i = 0; i < Math.min(rows.length, 20) && H < 0; i++) {
      var r = rows[i].map(function (c) { return String(c).toLowerCase().trim(); });
      var n = r.findIndex(function (c) { return /^(art\.?[\s-]*nr\.?|artikel[\s-]*nr\.?|artikelnummer|art-nr\.?|material(nummer)?|sku|bestell[\s-]*nr\.?|hersteller[\s-]*nr\.?|nummer|item\s*no\.?|part\s*no\.?)$/.test(c); });
      var q = r.findIndex(function (c) { return /^(anzahl|menge|stk\.?|stück|qty|quantity|anz\.?)$/.test(c); });
      if (n >= 0 && q >= 0) { H = i; cNum = n; cQty = q; cName = r.findIndex(function (c) { return /^(artikel|bezeichnung|beschreibung|artikelname|name|description|produkt)$/.test(c); }); }
    }
    var out = [];
    if (H >= 0) {
      for (var j = H + 1; j < rows.length; j++) {
        var num = String(rows[j][cNum] == null ? '' : rows[j][cNum]).trim();
        var qty = parseFloat(String(rows[j][cQty]).replace(',', '.'));
        if (!num || !(qty > 0)) continue;
        out.push({ num: num, qty: Math.round(qty), name: cName >= 0 ? String(rows[j][cName] || '') : '' });
      }
      return out;
    }
    rows.forEach(function (r) { var l = lineFromTokens(r.map(function (c) { return String(c); })); if (l) out.push(l); });
    return out;
  }
  function lineFromTokens(tok) {
    tok = tok.map(function (t) { return t.trim(); }).filter(Boolean);
    if (tok.length < 2) return null;
    var num = null, qty = null, name = [];
    tok.forEach(function (t) {
      if (/^(x|×|stk\.?|stück|st\.?)$/i.test(t)) return;
      var t2 = t.replace(/^(\d+)\s*(x|stk\.?|stück)$/i, '$1');
      if (!num && /^[A-Za-z0-9][A-Za-z0-9.\/-]{4,}$/.test(t) && /\d/.test(t) && !/^\d{1,4}$/.test(t)) { num = t; return; }
      if (qty === null && /^\d{1,5}$/.test(t2)) { qty = parseInt(t2, 10); return; }
      name.push(t);
    });
    if (!num || !qty) return null;
    return { num: num, qty: qty, name: name.join(' ') };
  }
  function parsePaste(txt) {
    var out = [];
    txt.split(/\r?\n/).forEach(function (line) {
      var tok = line.split(/\t|;|,(?=\s*\S)|\s{2,}/);
      if (tok.length < 2) tok = line.split(/\s+/);
      var l = lineFromTokens(tok);
      if (l) out.push(l);
    });
    return out;
  }
  function parsePdf(buf) {
    return libPdf().then(function () { return window.pdfjsLib.getDocument({ data: buf }).promise; }).then(function (pdf) {
      var jobs = [];
      for (var i = 1; i <= pdf.numPages; i++) jobs.push(pdf.getPage(i).then(function (pg) { return pg.getTextContent(); }));
      return Promise.all(jobs);
    }).then(function (pages) {
      var lines = [];
      pages.forEach(function (tc) {
        var rows = {};
        tc.items.forEach(function (it) { if (!it.str || !it.str.trim()) return; var y = Math.round(it.transform[5] / 3); (rows[y] = rows[y] || []).push(it); });
        Object.keys(rows).map(Number).sort(function (a, b) { return b - a; }).forEach(function (y) {
          lines.push(rows[y].sort(function (a, b) { return a.transform[4] - b.transform[4]; }).map(function (it) { return it.str.trim(); }).join(' ').replace(/\s+/g, ' ').replace(/([A-Za-z])\s*[-\u2010-\u2015\u2212]\s+(?=[A-Za-z])/g, '$1-'));
        });
      });
      var items = [], info = { system: '', modules: 0, moduleName: '' };
      lines.forEach(function (l) {
        var m = l.match(/^(\d{1,3})\s+([A-Z]?\d{6,8})\s+(.+?)\s+(\d{1,5})\s+[\d.,]+\s*kg$/);
        if (m) items.push({ num: m[2], qty: parseInt(m[4], 10), name: m[3] });
        var s = l.match(/\b([SD]\s*-\s*Dome\s*6\.\d{2}[^\d]*?)(?:\s|$)/); if (s && !info.system) info.system = s[1].trim();
        var mm = l.match(/(\d{1,4})\s*\(\s*[\d.,]+\s*kWp\s*\)/); if (mm && !info.modules) info.modules = parseInt(mm[1], 10);
        var sm = l.match(/^Summe\s+(\d{1,4})\s+[\d.,]+\s*kWp/); if (sm && !info.modules) info.modules = parseInt(sm[1], 10);
        var mn = l.match(/\b(TSM-[\w.]+|[A-Z]{2,5}\d{3,}[\w.-]*)\b.*\bWp\b/); if (mn && !info.moduleName) info.moduleName = mn[1];
      });
      var joined = lines.join(' ');
      if (!info.system) { var s2 = joined.match(/\b([SD]\s*-\s*Dome\s*6\.\d{2})/); if (s2) info.system = s2[1]; }
      return { items: items, info: info, text: joined };
    });
  }

  /* ---------- 3. Zuordnen ---------- */
  var SYN = { black: 'schwarz', silver: 'silber', mc: 'mittelklemme', middle: 'mittelklemme', ec: 'endklemme', end: 'endklemme', clamp: '', set: '', universal: '', mm: '' };
  function tokens(s) {
    return String(s || '').toLowerCase().replace(/[–—]/g, '-').replace(/[(),]/g, ' ').split(/\s+/).map(function (t) { return SYN.hasOwnProperty(t) ? SYN[t] : t; }).filter(function (t) { return t && t.length > 1; });
  }
  function fuzzy(name, vendorHint) {
    var ft = tokens(name); if (ft.length < 2) return null;
    var best = null, second = 0;
    PRODUCTS.forEach(function (p) {
      if (vendorHint && p.v !== vendorHint) return;
      if (p.y === 'UK-Set') return;
      var pt = tokens(p.t).join(' ');
      var hit = ft.filter(function (t) { return pt.indexOf(t) >= 0; }).length / ft.length;
      if (!best || hit > best.score) { second = best ? best.score : 0; best = { p: p, score: hit }; } else if (hit > second) second = hit;
    });
    if (best && best.score >= 0.75 && best.score - second >= 0.2) return best.p;
    return null;
  }
  function predictive(num) {
    var u = '/search/suggest.json?q=' + encodeURIComponent(num) + '&resources[type]=product&resources[limit]=1&resources[options][fields]=variants.sku,variants.barcode,title,tag';
    return fetch(u).then(function (r) { return r.json(); }).then(function (d) {
      var p = d && d.resources && d.resources.results && d.resources.results.products && d.resources.results.products[0];
      if (!p) return null;
      return fetch('/products/' + p.handle + '.js').then(function (r) { return r.json(); }).then(function (j) {
        var v = j.variants[0];
        return { h: j.handle, t: j.title, v: j.vendor, img: j.featured_image, vs: [{ id: v.id, t: v.title, p: v.price, ok: v.available, s: v.sku }] };
      });
    }).catch(function () { return null; });
  }
  function match(lines) {
    var k2 = lines.some(function (l) { return /^20\d{5}$|^10\d{5}$/.test(norm(l.num)); });
    var vendorHint = k2 ? 'K2 Systems' : '';
    return Promise.all(lines.map(function (l) {
      var e = IDX[norm(l.num)];
      if (e) return { line: l, p: e.p, v: e.v, state: e.alt ? 'alt' : 'ok', on: true };
      var f = l.name ? fuzzy(l.name, vendorHint) : null;
      if (f) return { line: l, p: f, v: f.vs[0], state: 'guess', on: false, why: 'name' };
      return predictive(l.num).then(function (p) {
        if (p) return { line: l, p: p, v: p.vs[0], state: 'guess', on: false, why: 'search' };
        return { line: l, state: 'none', on: false };
      });
    }));
  }

  /* ---------- 4. Dachart / Belegung ---------- */
  function roofFrom(lines, info) {
    var t = (info && info.system ? info.system + ' ' : '') + lines.map(function (l) { return l.name + ' '; }).join('');
    t = t.replace(/[\u2010-\u2015\u2212]/g, '-');
    var r = { type: '', tilt: 0 };
    if (/\bD\s*-\s*Dome/i.test(t)) r.type = 'ow'; else if (/\bS\s*-\s*Dome/i.test(t)) r.type = 'sued';
    else if (/FlatTile|\bFLA\b|Biber/i.test(t)) r.type = 'biber';
    else if (/SingleHook|SolidHook|Ziegel|\bPAN\b|Vario/i.test(t)) r.type = 'ziegel';
    else if (/MiniRail|Trapez|SpeedRail/i.test(t)) r.type = 'trapez';
    else if (/Falz|S-5|Medi/i.test(t)) r.type = 'stehfalz';
    else if (/Dome/i.test(t)) r.type = 'sued';
    var tl = t.match(/6\.(10|15)/); if (tl) r.tilt = parseInt(tl[1], 10);
    return r;
  }
  var ROOF = { ow: 'Flachdach Ost-West', sued: 'Flachdach Süd', ziegel: 'Ziegeldach', biber: 'Biberschwanzdach', trapez: 'Trapezblech', stehfalz: 'Stehfalzdach' };
  var ROOFKEY = { ow: 'Ost-West', sued: 'Flachdach Süd', ziegel: 'Ziegeldach', biber: 'Biberschwanz' };
  function moduleGuess(res) {
    var n = 0;
    res.forEach(function (r) { var nm = (r.line.name || '') + ' ' + (r.p ? r.p.t : ''); if (/K2MI|Mittelklemme|\bMC\b/i.test(nm) && r.line.qty > n) n = r.line.qty; });
    return n;
  }
  function enerackFor(roof, n) {
    var key = ROOFKEY[roof.type]; if (!key || !n) return null;
    var prod = SETS.filter(function (p) { return /Enerack/i.test(p.t) && p.t.indexOf(key) >= 0; })[0];
    if (!prod) return null;
    var cands = prod.vs.map(function (v) { var m = v.t.match(/(\d+)\s*Module/); return { v: v, n: m ? parseInt(m[1], 10) : 0 }; }).filter(function (c) { return c.n >= n; }).sort(function (a, b) { return a.n - b.n; });
    if (!cands.length) return { prod: prod, v: null };
    return { prod: prod, v: cands[0].v, n: cands[0].n };
  }

  /* ---------- 5. Anzeige ---------- */
  var STATE = { res: [], info: null, roof: null, mod: 0, choice: 'a', src: '' };
  var CHIP = { ok: ['ok', 'Gefunden'], alt: ['alt', 'Nachfolger'], guess: ['guess', 'Vorschlag'], none: ['none', 'Nicht gefunden'] };
  function hint(r) {
    if (r.state === 'alt') return 'Ersetzt ' + r.line.num + ' (Auslaufartikel) durch Nachfolger ' + (r.p.n && r.p.n[0] ? r.p.n[0] : r.v.s);
    if (r.state === 'guess') return 'Zugeordnet zu Stücklisten-Position „' + (r.line.name || r.line.num) + '“ (Art.-Nr. ' + r.line.num + ')';
    return '';
  }
  function render() {
    var res = STATE.res, html = '', sum = 0, cnt = 0, miss = 0;
    res.forEach(function (r, i) {
      var c = CHIP[r.state];
      var price = r.v ? r.v.p : 0;
      if (r.on && r.v) { sum += price * r.line.qty; cnt++; }
      if (r.state === 'none') miss++;
      html += '<div class="lxqo-row lxqo-row--' + c[0] + (r.on ? '' : ' is-off') + '">' +
        '<label class="lxqo-chk">' + (r.v ? '<input type="checkbox" data-i="' + i + '"' + (r.on ? ' checked' : '') + '>' : '') + '</label>' +
        '<div class="lxqo-src"><span class="lxqo-chip lxqo-chip--' + c[0] + '">' + c[1] + '</span><small>' + esc(r.line.num) + (r.line.name ? ' · ' + esc(r.line.name) : '') + '</small></div>' +
        '<div class="lxqo-prod">' + (r.p ? (r.p.img ? '<img src="' + esc(r.p.img) + '" alt="" width="44" height="44" loading="lazy">' : '') + '<a href="/products/' + esc(r.p.h) + '" target="_blank" rel="noopener">' + esc(r.p.t) + '</a>' + (r.v && !r.v.ok ? '<em class="lxqo-na">derzeit nicht verfügbar</em>' : '') : '<span class="lxqo-muted">Kein passender Artikel im Shop</span>') +
        (hint(r) ? '<span class="lxqo-hint">' + esc(hint(r)) + '</span>' : '') +
        (r.state === 'guess' && !r.on ? '<button type="button" class="lxqo-ok" data-ok="' + i + '">Vorschlag übernehmen</button>' : '') + '</div>' +
        '<div class="lxqo-qty">' + (r.v ? '<input type="number" min="0" step="1" value="' + r.line.qty + '" data-q="' + i + '" aria-label="Menge">' : r.line.qty) + '</div>' +
        '<div class="lxqo-pr">' + (r.v ? fmt(price) : '–') + '</div>' +
        '<div class="lxqo-tot">' + (r.v ? fmt(price * r.line.qty) : '–') + '</div>' +
        '</div>';
    });
    $('.lxqo-list').innerHTML = html;
    $('.lxqo-step2').hidden = !res.length;
    $('.lxqo-miss').hidden = !miss;
    if (miss) {
      var body = 'Folgende Positionen meiner Stückliste habe ich im Shop nicht gefunden:\n\n' + res.filter(function (r) { return r.state === 'none'; }).map(function (r) { return r.line.qty + ' × ' + r.line.num + ' ' + (r.line.name || ''); }).join('\n');
      $('.lxqo-miss a').href = 'mailto:' + SHOP_MAIL + '?subject=' + encodeURIComponent('Anfrage aus der Schnellbestellung') + '&body=' + encodeURIComponent(body);
      $('.lxqo-miss b').textContent = miss;
    }
    STATE.sumA = sum;
    renderChoice();
    var B = STATE.choice === 'b' && STATE.en && STATE.en.v;
    $('.lxqo-sum').textContent = fmt(B ? STATE.en.v.p : sum);
    $('.lxqo-cnt').textContent = B ? '1 Komplettset' : cnt + (cnt === 1 ? ' Position' : ' Positionen');
    $('.lxqo-go').disabled = B ? !STATE.en.v.ok : !cnt;
  }
  function renderChoice() {
    var box = $('.lxqo-choice'), roof = STATE.roof;
    var can = roof && ROOFKEY[roof.type] && STATE.res.length && /^(20|10)\d{5}$/.test(norm(STATE.res[0].line.num));
    if (!can) { box.hidden = true; STATE.choice = 'a'; return; }
    box.hidden = false;
    $('.lxqo-roof').textContent = ROOF[roof.type] + (roof.tilt ? ' ' + roof.tilt + '°' : '');
    var nIn = $('.lxqo-mods');
    if (document.activeElement !== nIn) nIn.value = STATE.mod || '';
    $('.lxqo-modsrc').textContent = STATE.modSrc || '';
    STATE.en = enerackFor(roof, STATE.mod);
    $('.lxqo-a-sum').textContent = fmt(STATE.sumA || 0);
    var b = $('.lxqo-b'), bt = $('.lxqo-b-body');
    if (!STATE.mod) { bt.innerHTML = '<p>Bitte Anzahl Module eintragen, dann wird das passende Enerack-Komplettset gesucht.</p>'; b.classList.add('is-dis'); if (STATE.choice === 'b') STATE.choice = 'a'; }
    else if (!STATE.en || !STATE.en.v) { bt.innerHTML = '<p>Für ' + esc(ROOF[roof.type]) + ' mit ' + STATE.mod + ' Modulen gibt es kein passendes Enerack-Set. Gerne planen wir individuell.</p>'; b.classList.add('is-dis'); if (STATE.choice === 'b') STATE.choice = 'a'; }
    else {
      b.classList.remove('is-dis');
      var en = STATE.en, diff = (STATE.sumA || 0) - en.v.p;
      var notes = [];
      if (en.n !== STATE.mod) notes.push('Set für ' + en.n + ' Module (nächste verfügbare Größe über ' + STATE.mod + ')');
      var vt = en.v.t.match(/(\d+)°/); if (vt && roof.tilt && parseInt(vt[1], 10) !== roof.tilt) notes.push(vt[1] + '° statt ' + roof.tilt + '° Modulneigung');
      if (en.v.f) notes.push('Belegung im Set: ' + en.v.f.split('|')[0].split(',').join(' + ') + ' Module je Reihe');
      bt.innerHTML = '<strong>' + esc(en.prod.t) + '</strong><span>' + esc(en.v.t) + '</span><b class="lxqo-b-sum">' + fmt(en.v.p) + '</b>' +
        (diff > 0 ? '<span class="lxqo-save">' + fmt(diff) + ' günstiger als K2</span>' : (diff < 0 ? '<span class="lxqo-more">' + fmt(-diff) + ' teurer als K2</span>' : '')) +
        (notes.length ? '<ul>' + notes.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
        '<p class="lxqo-warn">⚠ <strong>Stückliste für Enerack neu ermittelt.</strong> Die Enerack-Teile ergeben sich aus Dachart und Modulanzahl, nicht 1:1 aus den K2-Teilen. Statik, Ballast und Randabstände aus Ihrem K2-Bericht gelten nur für K2 und müssen für Enerack neu geprüft werden.</p>';
    }
    root.querySelectorAll('input[name=lxqo-sys]').forEach(function (x) { x.checked = x.value === STATE.choice; });
  }

  /* ---------- 6. Ablauf ---------- */
  function status(t, err) { var s = $('.lxqo-status'); s.textContent = t || ''; s.className = 'lxqo-status' + (err ? ' is-err' : ''); s.hidden = !t; }
  function run(lines, info, src) {
    if (!lines.length) { status('In der Datei wurden keine Artikelnummern mit Mengen erkannt. Bitte prüfen Sie die Datei oder fügen Sie die Liste unten ein.', true); return; }
    status('Artikel werden im Shop gesucht …');
    ensureData().then(function () { return match(lines); }).then(function (res) {
      STATE.res = res; STATE.info = info || null; STATE.src = src;
      STATE.roof = roofFrom(lines, info);
      if (info && info.modules) { STATE.mod = info.modules; STATE.modSrc = 'aus Ihrem K2-Bericht'; }
      else { STATE.mod = moduleGuess(res); STATE.modSrc = STATE.mod ? 'geschätzt – bitte prüfen' : ''; }
      STATE.choice = 'a';
      var f = res.filter(function (r) { return r.state === 'ok' || r.state === 'alt'; }).length;
      status(f + ' von ' + res.length + ' Positionen direkt zugeordnet' + (info && info.modules ? ' · ' + info.modules + ' Module laut Bericht' : '') + '.');
      render();
      $('.lxqo-step2').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }).catch(function (e) { console.error(e); status('Die Shop-Daten konnten nicht geladen werden. Bitte Seite neu laden.', true); });
  }
  function handleFile(file) {
    if (!file) return;
    status('Datei wird gelesen …');
    var name = file.name.toLowerCase();
    readBuf(file).then(function (buf) {
      if (/\.pdf$/.test(name)) return parsePdf(buf).then(function (d) { run(d.items, d.info, 'pdf'); });
      return libXlsx().then(function () {
        var wb = window.XLSX.read(new Uint8Array(buf), { type: 'array' });
        var ws = wb.Sheets[wb.SheetNames[0]];
        var rows = window.XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, defval: '' });
        run(linesFromSheetRows(rows), null, 'xlsx');
      });
    }).catch(function (e) { console.error(e); status('Die Datei konnte nicht gelesen werden (' + (e && e.message ? e.message : 'unbekannter Fehler') + ').', true); });
  }

  var drop = $('.lxqo-drop'), inp = $('.lxqo-file');
  drop.addEventListener('click', function () { inp.click(); });
  drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); inp.click(); } });
  inp.addEventListener('change', function () { handleFile(inp.files[0]); inp.value = ''; });
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; handleFile(f); });
  $('.lxqo-paste-go').addEventListener('click', function () { run(parsePaste($('.lxqo-paste').value), null, 'paste'); });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('input[data-i]')) { STATE.res[+t.getAttribute('data-i')].on = t.checked; render(); }
    if (t.matches('input[data-q]')) { var q = Math.max(0, parseInt(t.value, 10) || 0); var r = STATE.res[+t.getAttribute('data-q')]; r.line.qty = q; r.on = q > 0 && r.on; render(); }
    if (t.matches('input[name=lxqo-sys]')) { if (t.value === 'b' && $('.lxqo-b').classList.contains('is-dis')) { t.checked = false; return; } STATE.choice = t.value; render(); }
    if (t.matches('.lxqo-mods')) { STATE.mod = Math.max(0, parseInt(t.value, 10) || 0); STATE.modSrc = 'Ihre Angabe'; render(); }
    if (t.matches('.lxqo-confirm')) { $('.lxqo-modal-go').disabled = !t.checked; }
  });
  root.addEventListener('click', function (e) {
    var ok = e.target.closest('[data-ok]');
    if (ok) { STATE.res[+ok.getAttribute('data-ok')].on = true; render(); }
    if (e.target.closest('.lxqo-go')) { if (STATE.choice === 'b') openModal(); else addToCart(); }
    if (e.target.closest('.lxqo-modal-x')) closeModal();
    if (e.target.closest('.lxqo-modal-go')) { closeModal(); addToCart(); }
  });
  function openModal() { var m = $('.lxqo-modal'); $('.lxqo-confirm').checked = false; $('.lxqo-modal-go').disabled = true; if (m.showModal) m.showModal(); else m.setAttribute('open', ''); }
  function closeModal() { var m = $('.lxqo-modal'); if (m.close) m.close(); else m.removeAttribute('open'); }

  function addToCart() {
    var items = [];
    if (STATE.choice === 'b' && STATE.en && STATE.en.v) {
      var r = STATE.roof;
      items.push({ id: STATE.en.v.id, quantity: 1, properties: {
        'Hinweis': 'Gewählt statt K2-Planung – Statik, Ballast und Randabstände für Enerack bauseits zu prüfen (Hinweis bestätigt)',
        'Laut Planung': ROOF[r.type] + (r.tilt ? ' ' + r.tilt + '°' : '') + ', ' + STATE.mod + ' Module'
      } });
    } else {
      STATE.res.forEach(function (x) {
        if (!x.on || !x.v || !(x.line.qty > 0)) return;
        var it = { id: x.v.id, quantity: x.line.qty };
        var h = hint(x); if (h) it.properties = { 'Hinweis': h };
        items.push(it);
      });
    }
    if (!items.length) return;
    var btn = $('.lxqo-go'); btn.disabled = true; btn.textContent = 'Wird in den Warenkorb gelegt …';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (e) { btn.disabled = false; btn.textContent = 'Alle in den Warenkorb'; status('Nicht alles konnte in den Warenkorb gelegt werden: ' + e.message, true); });
  }
})();
